import * as React from "react";
import { forwardRef } from "react";
const SvgTurnRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 17", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.95 3.741a7 7 0 0 1 2.039 4.574l.302-.302a.996.996 0 0 1 1.414 0 1.005 1.005 0 0 1 0 1.423l-2 2.01a.995.995 0 0 1-1.414 0l-2-2.01a1.005 1.005 0 0 1 1.09-1.64q.183.076.324.217l.273.269a5 5 0 1 0-8.516 3.99A4.95 4.95 0 0 0 7 13.744a1.005 1.005 0 1 1 0 2.01 6.93 6.93 0 0 1-4.949-2.061 7.063 7.063 0 0 1 0-9.954 6.97 6.97 0 0 1 9.898 0z" }));
const ForwardRef = forwardRef(SvgTurnRight);
export { ForwardRef as ReactComponent };
